import React, { useEffect, useMemo, memo } from 'react'
import styles from '../../styles.module.css'
import Button from '../../../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Table from '../../../../components/Table'
import { getPeriodGroups } from '../../../../actions/periods'
import { BiTrash } from 'react-icons/bi'
import ModalExceptions from './ModalExcpections'

export const DAY_NAMES = ['понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота', 'воскресенье']

const formatDate = (date) => {
  if (!date) return ''
  const [y, m, d] = date.split('-')
  return d && m && y ? `${d}.${m}.${y}` : date
}

const Exceptions = memo(function Exceptions({ search, exclusions, onAdd, onUpdate, onRemove }) {

  const dispatch = useDispatch()
  const { groups } = useSelector(state => state.periods)
  console.log('groups::: ', groups);

  const [editingItem, setEditingItem] = useState(null)
  const [isAdding, setIsAdding] = useState(false)

  useEffect(() => {
    if (search?.year) dispatch(getPeriodGroups(search.year))
  }, [dispatch, search?.year])

  const classNameById = useMemo(() => {
    const map = {}
    groups?.forEach(c => { map[c.gid] = c.name })
    return map
  }, [groups])

  const getLabel = (item) => {
    if (item.type === 'date') return formatDate(item.date)
    if (item.type === 'dow') return DAY_NAMES[item.day_of_week] || ''
    if (item.type === 'class') return classNameById[item.gid] || ''
    return ''
  }

  const openAdd = () => setIsAdding(true)
  const openEdit = (item) => () => setEditingItem(item)
  const closeForm = () => { setIsAdding(false); setEditingItem(null) }

  const handleSave = (record) => {
    if (editingItem) {
      onUpdate(editingItem, record)
    } else {
      onAdd(record)
    }
    closeForm()
  }

  const handleRemove = (item) => (e) => {
    e.stopPropagation()
    onRemove(item)
  }

  return (
    <div className={styles.wrapper}>
      {(isAdding || editingItem) &&
        <ModalExceptions
          open
          data={editingItem}
          groups={groups}
          onSave={handleSave}
          closeModal={closeForm}
        />
      }
      <div className={styles.tablePeriods}>
        <Table style={{ marginTop: '0', backgroundColor: 'white' }}>
          <thead>
            <tr className={styles.thead}>
              <th>С</th>
              <th>По</th>
              <th>Исключение</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {exclusions?.map((item, idx) => (
              <tr key={item.peid || item._tempId || idx} onClick={openEdit(item)} style={{ cursor: 'pointer' }}>
                <td>{item.starttime}</td>
                <td>{item.stoptime}</td>
                <td>{getLabel(item)}</td>
                <td><i className={styles.trash} onClick={handleRemove(item)}><BiTrash /></i></td>
              </tr>
            ))}
            {!exclusions?.length &&
              <tr><td colSpan={4} style={{ textAlign: 'center' }}>Исключений нет. Нажмите «Добавить».</td></tr>
            }
          </tbody>
        </Table>
      </div>
      <div className={styles.buttons}>
        <Button icon={IoIosAdd} onClick={openAdd}><IoIosAdd size={30} />Добавить</Button>
      </div>
    </div>
  )
}, (prevProps, nextProps) => {
  return prevProps.search?.year === nextProps.search?.year &&
    prevProps.search?.shift === nextProps.search?.shift &&
    prevProps.exclusions === nextProps.exclusions
})

export default Exceptions
